import { Card, Text, InlineStack, Button, BlockStack, SkeletonBodyText, EmptyState, Link, ProgressBar, Icon, Badge, Tooltip, Divider, SkeletonTabs, SkeletonDisplayText, SkeletonThumbnail, TextContainer, Banner } from '@shopify/polaris';
import React, { useEffect, useRef, useState } from 'react';
import { Socket } from 'socket.io-client';
import { DefaultEventsMap } from 'socket.io/dist/typed-events';
import { DIProps } from '../../../../Core';
import NoResultsFound from "../../../../Asests/Images/NoResultsFound.png"
import { imageselction, isLinkValid } from '../Utils/HelperFunc';
import { ClockMajor, InfoMinor, TickMinor } from '@shopify/polaris-icons';
import Amazon from "../../../../Asests/Images/amazon.png"
import Shopify from "../../../../Asests/Images/shopify.png"
import { ClockIcon } from '../../../../Asests/svgIcon/icon';
import { Timer } from '../../Activity/Component/Activity';
import { isAdminLoggedIn } from '../../Panel/index';
import { useTranslation } from 'react-i18next';

interface Props extends DIProps { }

const MAX_RETRIES = 5; // Max reconnection attempts
const INITIAL_RETRY_DELAY = 1000; // 1 second
const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes (600,000ms)

let retryAttempts = 0;
let retryTimeout: NodeJS.Timeout | null = null;
let inactivityTimer: NodeJS.Timeout | null = null;



const Activities = (Props: Props) => {
    const { t } = useTranslation();
    const count: number = 5;


    const processCodeMapping: any = {
        'price_sync': t('Amazon Price Sync'),
        'saleschannel_product_import': t('Shopify Product Import'),
        'product_import': t('Shopify Product Import'),
        'amazon_product_image': t('Amazon Sync Status'),
        'amazon_product_search': t('Amazon Lookup'),
        'csv_product': t('Bulk Export'),
        'product_upload': t('Amazon Product Upload'),
        'amazon_account': t('Amazon account connection'),
        'product_update': t('Amazon Product Update'),
        'image_sync': t('Amazon Image Sync'),
        'shopify_image_sync': t('Image Sync'),
        'shopify_inventorysync': t('Inventory Sync'),
        'shopify_price_sync': t('Price Sync'),
        'payment': t('Payment Process'),
        'amazon_product_report': t('Amazon Sync Status'),
        'product_delete': t('Amazon Product Delete'),
        'inventory_sync': t('Amazon Inventory Sync'),
        'payment_process_plan': t('Payment Process'),
        'payment_process_settlement': t('Payment Process'),
        'payment_process_custom': t('Payment Process'),
        'payment_process': t("Payment Process"),
        'metafield': t("Shopify Metafield Import"),
        "account_status": t("Amazon Account"),
        "template_bulk_edit_import": t("Bulk Product Attributes Import"),
        "template_bulk_edit_export": t("Bulk Product Attributes Export"),
        "template_bulk_attribute_delete_export": t("Bulk Product Attributes Delete"),
        "batch_product_import": "Shopify Batch Product Import",
        "metafield_import": "Shopify Metafield Import",
        "amazon_product_custom_report": t('Amazon Sync Status'),
        "amazon_fetch_product_type": "Amazon Product type Assignment is in process"

    }

    const messages: any = {
        'Product upload initiated': 'Product upload',
        "Inventory sync initiated": "Inventory sync",
        "Price sync initiated": "Price sync",
        "Amazon Lookup is in progress": "Amazon Lookup",
        "Product delete initiated": "Product Delete",
        "Success! Sync Status Report request submitted on Amazon.": "Sync status"
    }

    const [notification, setnotification] = useState<any>([])
    const [newNotification, setNewNotification] = useState<any>([])
    const [newQueuedTask, setNewQueuedTask] = useState<any>([])
    const [queudTask, setqueudTask] = useState<any>([])
    const [queueCount, setQueueCount] = useState<number>(0);
    const [notificationCount, setNotificationCount] = useState<number>(0);
    const [loading, setloading] = useState<boolean>(true)
    const [notificationLoader, setNotificationLoader] = useState<boolean>(true);
    const [queuedTaskId, setQueuedTaskId] = useState<any>([]);
    const [activeToast, setActiveToast] = useState({ open: false, refresh: false });
    const [pendingImportProductCount, setPendingImportProductCount] = useState<number>(0);
    const [showPendingImportBanner, setShowPendingImportBanner] = useState<Boolean>(false);

    const [flag, setFlag] = useState<Boolean>(false);

    useEffect(() => {
        getPendingBatchImportProducts();
    }, [])
    const getPendingBatchImportProducts = () => {
        Props.di.GET('shopifyhome/request/getPendingBatchImportProducts', {
            user_id: Props.redux.user_id,
            shop_id: Props.di.globalState.get('source_id'),  //shopify shop_id
            count_only: true
        }).then((response: any) => {
            if (response?.success) {
                setPendingImportProductCount(response?.data?.count || 0);
                if (response?.data?.count > 0) setShowPendingImportBanner(true)
            }
            else {
                setShowPendingImportBanner(false);
                setPendingImportProductCount(0);
            }
        })
    }

    function getQueudTasks() {
        Props.di.GET("connector/get/allQueuedTasks").then((Data) => {
            if (Data.success && JSON.stringify(queudTask) != JSON.stringify(Data.data.row)) {
                let temp: any = [...queuedTaskId];

                Data?.data?.rows?.forEach((task: any) => {
                    temp.push(task?.['_id']?.['$oid'])
                })

                setQueuedTaskId(temp);
                setqueudTask(Data?.data?.rows);

                if (Data?.data?.count < 5) {
                    setQueueCount(Data?.data?.count);
                    setNotificationCount(count - Data?.data?.count);
                }
                else {
                    setQueueCount(count);
                    setNotificationCount(0);
                }
                setloading(false)
            }

        })
    }




    //to get all notification(Continious call)
    const getNotifications = () => {
        Props.di.GET(`connector/get/allNotifications?activePage=1&count=${count}`).then((Data) => {
            if (Data.success) {
                const newRows: any = [];
                const rows = Data.data.rows;
                rows.forEach((ele: any) => {
                    newRows.push({
                        ...ele,
                        // created_at: ele.created_at.replace("+00:00", " GMT"),// written in old app
                        created_at: new Date(ele.created_at).toUTCString(),
                    });
                });
                setnotification(newRows);
                setNotificationLoader(false);
            }
        })
    }


    let wsRef = useRef<WebSocket | null>(null);


    const [isUserActive, setIsUserActive] = useState(true);


    const resetInactivityTimer = () => {
        if (inactivityTimer) {
            clearTimeout(inactivityTimer);
        }

        inactivityTimer = setTimeout(() => {
            setIsUserActive(false);
        }, INACTIVITY_TIMEOUT);
    };



    // Track user activity
    useEffect(() => {
        const updateUserActivity = (event: Event) => {
            let activityType = event.type === "mousemove" ? "Mouse Movement" :
                event.type === "keydown" ? "Key Press" :
                    event.type === "focus" ? "Window Focus" : "Unknown";

            setIsUserActive(true);
            resetInactivityTimer();
        };

        window.addEventListener("mousemove", updateUserActivity);
        window.addEventListener("keydown", updateUserActivity);
        window.addEventListener("focus", updateUserActivity);

        resetInactivityTimer(); // Start inactivity timer when the component mounts

        return () => {
            window.removeEventListener("mousemove", updateUserActivity);
            window.removeEventListener("keydown", updateUserActivity);
            window.removeEventListener("focus", updateUserActivity);
            if (inactivityTimer) {
                clearTimeout(inactivityTimer);
            }
        };
    }, []);

    const connectWebSocket = () => {
        if (!isUserActive) {
            return;
        }

        if (wsRef.current && wsRef.current.readyState !== WebSocket.CLOSED) {
            return; // Prevent duplicate connections
        }

        wsRef.current = new WebSocket('wss://a5zls8ce93.execute-api.us-east-2.amazonaws.com/beta');

        wsRef.current.onopen = () => {
            retryAttempts = 0; // Reset retry counter
            if (retryTimeout) {
                clearTimeout(retryTimeout);
                retryTimeout = null;
            }
            setActiveToast(prev => ({ ...prev, open: false }));

            const clientIdString = process.env.REACT_APP_WEBSOCKET_CLIENT_ID;
            if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN && clientIdString) {
                wsRef.current.send(JSON.stringify({
                    action: "identity",
                    client_id: parseInt(clientIdString),
                    customer_id: Props.di.globalState.get("user_id"),
                    token: Props.di.globalState.getBearerToken()
                }));
            }
        };

        wsRef.current.onmessage = (event) => {
            const data = JSON.parse(event?.data);
            if (data.feed && !Array.isArray(data.feed)) {
                if (data.feed.shop_id === Props?.redux?.current?.source?._id || data.feed.shop_id === Props?.redux?.current?.target?._id) {
                    setNewQueuedTask(data.feed);
                }
            } else if (data.notification && !Array.isArray(data.notification)) {
                if (data.feed.shop_id === Props?.redux?.current?.source?._id || data.feed.shop_id === Props?.redux?.current?.target?._id) {
                    setNewNotification(data.notification);
                }
            }
        };

        wsRef.current.onerror = (error) => {
            console.error('WebSocket error:', error);
        };

        wsRef.current.onclose = () => {
            setActiveToast(prev => ({ ...prev, open: true }));

            if (isUserActive) {
                handleReconnect();
            } else {
                console.log('User has been inactive for 10 minutes. Not reconnecting.');
            }
        };
    };

    const handleReconnect = () => {
        setTimeout(() => {
            setIsUserActive((currentIsUserActive) => {
                if (!currentIsUserActive) {
                    return false; // Ensure no reconnection
                }

                if (retryAttempts >= MAX_RETRIES) {
                    return true; // Stop further retries
                }

                const retryDelay = INITIAL_RETRY_DELAY * Math.pow(2, retryAttempts);

                retryAttempts++;
                connectWebSocket();
                return true;
            });
        }, 1000); // Wait 1 second before checking again
    };

    useEffect(() => {
        getNotifications();
        getQueudTasks();
        connectWebSocket();

        return () => {
            if (wsRef.current) {
                wsRef.current.close();
            }
            if (retryTimeout) {
                clearTimeout(retryTimeout);
            }
            if (inactivityTimer) {
                clearTimeout(inactivityTimer);
            }
        };
    }, [activeToast.refresh]);


    const handleclose = () => {
        setNotificationLoader(true);
        setloading(true);
        setActiveToast({ open: false, refresh: !activeToast.refresh })
    }



    useEffect(() => {
        let temp: any = [{ ...newNotification }, ...notification,]
        setnotification([...temp])

    }, [newNotification])

    useEffect(() => {
        if (newQueuedTask.progress === 100) {
            // Remove the task from the queue if progress is 100
            setqueudTask((prevQueue: any) => {
                return prevQueue.filter((task: any) => task?._id?.$oid !== newQueuedTask?._id?.$oid);
            });
            if (queudTask?.filter((task: any) => task?._id?.$oid !== newQueuedTask?._id?.$oid)?.length < 5) {
                setQueueCount(queudTask?.filter((task: any) => task?._id?.$oid !== newQueuedTask?._id?.$oid)?.length);
                setNotificationCount(count - queudTask?.filter((task: any) => task?._id?.$oid !== newQueuedTask?._id?.$oid)?.length);
            }
            else {
                setQueueCount(count);
                setNotificationCount(0);
            }

        } else {
            // Task progress is not 100, update or add it to the queue
            setqueudTask((prevQueue: any) => {
                const existingIndex = prevQueue.findIndex((task: any) => task?._id?.$oid === newQueuedTask?._id?.$oid);
                if (existingIndex !== -1) {
                    // Task already exists, update it
                    const updatedQueue = [...prevQueue];
                    updatedQueue[existingIndex] = { ...newQueuedTask };
                    return updatedQueue;
                } else {
                    // Task doesn't exist, add it to the queue
                    if ([{ ...newQueuedTask }, ...prevQueue]?.length < 5) {
                        setQueueCount([{ ...newQueuedTask }, ...prevQueue]?.length);
                        setNotificationCount(count - [{ ...newQueuedTask }, ...prevQueue]?.length);
                    }
                    else {
                        setQueueCount(count);
                        setNotificationCount(0);
                    }
                    return [{ ...newQueuedTask }, ...prevQueue];
                }
            });
        }


    }, [newQueuedTask]);


    const renderNotificationAction = (data: any, ind: number) => {
        if (data?.hasOwnProperty('do_notify') && data['do_notify'] === 'link') {
            return <Link url={data['content']} >{t("know more")}</Link>
        }
    }


    const handleCSVfile = (activityData: any) => {

        const payload = {
            _id: activityData['_id']['$oid'] ?? activityData['_id'],
            url: activityData?.url
        }
        Props.di.GET("connector/csv/S3fileDownload", payload).then((data: any) => {
            if (data.success) {
                const link = document.createElement('a');
                link.href = activityData?.url;
                link.setAttribute('download', ''); // This attribute triggers the download
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                let TempNotification = [...notification]
                let foundIndex = TempNotification.findIndex((item: any) => item._id["$oid"] === data?.data?._id?.['$oid'] || item._id === data?.data?._id?.['$oid']);
                if (foundIndex !== -1) {
                    TempNotification[foundIndex].additional_data.downloaded = data?.additional_data?.downloaded ?? true;
                    TempNotification[foundIndex].additional_data.current = true;

                }
                setnotification([...TempNotification])
                Props.success(t("File Downloaded Started"))
            } else {
                Props.error(t(data?.message))
            }
        })
    }



    return (
        <Card roundedAbove='sm'>
            <BlockStack gap="300">
                <BlockStack gap="200">
                    <InlineStack wrap={false} gap="200" align='space-between'>
                        <Text variant="headingMd" as="h6">{t("Recent Activities")}</Text>
                        <Button variant="plain" onClick={() => { Props.history("../home/activity") }}>{t("All Activities")}</Button>
                    </InlineStack>
                    <Text variant="bodyLg" as="p" tone="subdued">{t("Stay updated on all of your recent activities from here.")}</Text>
                </BlockStack>
                <Card >
                    <BlockStack gap="200">
                        {
                            showPendingImportBanner === true &&
                            <Card background="bg-surface-secondary">
                                <InlineStack gap="200" blockAlign='start' wrap={false}>
                                    <div><Icon source={ClockMajor} tone="subdued" /></div>
                                    <BlockStack gap="100">
                                        <Text variant="headingMd" as="h6" fontWeight="medium">
                                            {t("Product Import Underway!")}
                                        </Text>
                                        <Text as="p" fontWeight="regular" tone='subdued'>
                                            {t("We're importing")} {' '}<Button variant='plain' onClick={() => Props.history('./activity/import')}>{`${pendingImportProductCount} ${t("new")} ${pendingImportProductCount > 1 ? t('products') : t('product')}`}</Button> {' '} {t("from Shopify. Please wait with us for sometime. Thank you for your patience!")}
                                        </Text>
                                    </BlockStack>
                                </InlineStack>
                            </Card>
                        }
                        {
                            loading && notificationLoader ?
                                <BlockStack gap='300'>
                                    <TextContainer>
                                        <SkeletonDisplayText size="small" />
                                        <SkeletonBodyText />
                                    </TextContainer>
                                    <Divider />
                                    <TextContainer>
                                        <SkeletonDisplayText size="small" />
                                        <SkeletonBodyText />
                                    </TextContainer>
                                    <Divider />
                                    <TextContainer>
                                        <SkeletonDisplayText size="small" />
                                        <SkeletonBodyText />
                                    </TextContainer>
                                    <Divider />
                                    <TextContainer>
                                        <SkeletonDisplayText size="small" />
                                        <SkeletonBodyText />
                                    </TextContainer>
                                </BlockStack>
                                :
                                (notification.length > 0 || queudTask?.length > 0) ?
                                    <BlockStack gap='200'>
                                        <BlockStack gap='300'>
                                            {queudTask?.map((task: any, idx: number) => {
                                                return (
                                                    <React.Fragment key={task?.['created_at']}>
                                                        <BlockStack gap="200">
                                                            <InlineStack gap="300" align='space-between' wrap={false} blockAlign='center'>
                                                                <InlineStack align='start' gap="200" blockAlign='center'>

                                                                    <Text variant="headingSm" as="h6">{task?.additional_data?.process_label ?? processCodeMapping[task?.process_code] ?? t('App Process')}</Text>
                                                                    {
                                                                        task?.['process_initiation'] ?
                                                                            <Badge>{task?.process_initiation.charAt(0).toUpperCase() + task?.process_initiation.slice(1)}</Badge>
                                                                            : null
                                                                    }
                                                                </InlineStack>
                                                                <img alt='shopify' src={Props?.redux?.current?.target?.['_id'] == task?.shop_id ? Amazon : Shopify} />
                                                            </InlineStack>

                                                            <InlineStack align='start' gap="300" wrap={false}>
                                                                <div><Icon source={ClockIcon}></Icon></div>
                                                                <div className='Custom-Stack-Item--fill'>
                                                                    <BlockStack align='start' gap="100">
                                                                        <Text as='p' breakWord>{t(task?.message)}</Text>
                                                                        <Tooltip content={`${task?.progress}% ${t("Done")}`} dismissOnMouseOut>
                                                                            <ProgressBar progress={task?.progress || 0} tone="success" size="small" />
                                                                        </Tooltip>
                                                                        <em>
                                                                            <Text as="p" tone="subdued">{task['created_at'] != undefined && <Text as='span' tone='subdued'>{`${t("started")} ${new Date(task.created_at).toUTCString()}`}</Text>}</Text>
                                                                        </em>
                                                                    </BlockStack>
                                                                </div>
                                                            </InlineStack>
                                                        </BlockStack>
                                                        {notification?.length > 0 && <Divider />}
                                                    </React.Fragment>
                                                )
                                            })}
                                        </BlockStack>

                                        {/* NOTIFICATIONS */}
                                        {notification?.map((data: any, idx: number) => {
                                            let createdAtTimestamp;
                                            if (data.created_at && data.created_at.$date && typeof data.created_at.$date === 'object' && data.created_at.$date.$numberLong) {
                                                createdAtTimestamp = parseInt(data.created_at.$date.$numberLong);
                                            } else {
                                                // Fallback: parse as ISO date string
                                                createdAtTimestamp = Date.parse(data.created_at);
                                            }

                                            // Convert the timestamp to a Date object
                                            const createdAtDate = new Date(createdAtTimestamp);

                                            // Format the date to your desired format (e.g., "YYYY-MM-DD HH:MM:SS")
                                            const formattedDate = `${createdAtDate.getFullYear()}-${String(createdAtDate.getMonth() + 1).padStart(2, '0')}-${String(createdAtDate.getDate()).padStart(2, '0')} ${String(createdAtDate.getHours()).padStart(2, '0')}:${String(createdAtDate.getMinutes()).padStart(2, '0')}:${String(createdAtDate.getSeconds()).padStart(2, '0')}`;
                                            data['created_at'] = formattedDate;
                                            return (
                                                idx < notificationCount &&
                                                <React.Fragment key={idx + 1000}>
                                                    <BlockStack gap="300">
                                                        <InlineStack gap="300" align='space-between' wrap={false} blockAlign='center'>
                                                            <InlineStack align='start' gap="200" blockAlign='center'>
                                                                <Text variant="headingSm" as="h6">{data?.additional_data?.process_label ?? processCodeMapping[data?.process_code] ?? t('App Process')}</Text>
                                                                {
                                                                    data?.['process_initiation'] ?
                                                                        <Badge>{data?.process_initiation.charAt(0).toUpperCase() + data?.process_initiation.slice(1)}</Badge>
                                                                        : null
                                                                }
                                                            </InlineStack>
                                                            <img alt='shopify' src={Props?.redux?.current?.target?.['_id'] == data?.shop_id ? Amazon : Shopify} />
                                                        </InlineStack>

                                                        <InlineStack align='start' gap="100" wrap={false}>
                                                            <div>{imageselction(data["severity"])}</div>
                                                            <div className='Custom-Stack-Item--fill'>
                                                                <BlockStack align='start' gap="100">
                                                                    {
                                                                        data['url'] ?
                                                                            <InlineStack gap='200'>
                                                                                <Text as='span'>{t(data["message"])}</Text>
                                                                                {isLinkValid(data?.created_at) ? <Button variant='plain' onClick={() => handleCSVfile(data)} >{t("Download Now")}</Button> : null}
                                                                            </InlineStack>
                                                                            :
                                                                            data?.['additional_data']?.['force_delete'] ?
                                                                                <InlineStack>
                                                                                    <Text as='p'>
                                                                                        {t(data["message"])}
                                                                                    </Text>
                                                                                    <Tooltip content={data?.['additional_data']?.['force_delete']}>
                                                                                        <Icon source={InfoMinor}></Icon>
                                                                                    </Tooltip>
                                                                                </InlineStack> :
                                                                                <Text as='p'>
                                                                                    {t(data["message"])}
                                                                                </Text>
                                                                    }
                                                                    {renderNotificationAction(data, idx)}
                                                                    <em>
                                                                        <Text as="p" tone="subdued">{data['created_at'] != undefined && <Text as='span' tone='subdued'>{`started ${new Date(data.created_at).toUTCString()}`}</Text>}</Text>
                                                                    </em>
                                                                    {
                                                                        data['url'] && <Timer setFlag={setFlag} flag={flag} createdAt={(data?.created_at)}></Timer>

                                                                    }
                                                                </BlockStack>
                                                            </div>
                                                        </InlineStack>

                                                    </BlockStack>
                                                    {idx < notification?.length - 1 && <Divider />}
                                                </React.Fragment>
                                            );
                                        })}
                                    </BlockStack>
                                    :
                                    <EmptyState image={NoResultsFound} heading={t("No Activities found!")} />
                        }
                    </BlockStack>
                </Card>
            </BlockStack >
        </Card >
    );
}

export default Activities;